import React from "react";
import { connect } from "react-redux";
import AddQuestion from "./AddQuestion";
import { Redirect } from "react-router-dom";

function NewQuestion(props:any) {
  if (props.isLogged === false) {
    return <Redirect to="/login" />;
  }

  return <AddQuestion />;
}
const mapStateToProps = (state:any) => {
  return {
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

export default connect(mapStateToProps, null)(NewQuestion);
